import * as config from "./config";

export const users = `${config.apiUrl}/users`;
export const clothingCategories = `${config.apiUrl}/clothing-categories`;
export const clothes = `${config.apiUrl}/clothes`